import { Tab } from "@headlessui/react";
import CarCard from "components/CarCard/CarCard";
import React, { useEffect } from "react";
import CommonLayout from "./CommonLayout";
import { useServices } from "../../hooks/collections/useServices";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { useLoader } from "../../@shared/hooks/useLoader";
import { IService } from "../../@core/interfaces/IService";
import { Collections } from "../../@core/constants/FirebasePaths";
import { useOrders } from "../../hooks/collections/useOrdersV2";
import { NotFound } from "../../components/NotFound/NotFound";

const AccountServices = () => {
  const user = useUserSessionStore((state) => state.user);
  const { getReference } = useOrders({ loadData: false });
  const { services, fetched } = useServices(true, [
    { type: "where", field: "company", operator: "==", value: getReference(`${Collections.users._path}/${user?.id}`) },
    { type: "orderBy", field: "createdAt", direction: "desc" }
  ]);

  const navigate = useNavigate();
  const loader = useLoader();
  const redirectToServiceForm = (service?: IService) => {
    navigate(`/account-services/form${service ? `?id=${service.id}` : ''}`);
  };

  const redirectToService = (service: IService) => {
    navigate(`/service-detail/${service.id}`);
  };

  useEffect(() => {
    !fetched ? loader.start() : loader.stop(true);
  }, [fetched]);

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className={'flex justify-between items-center'}>
          <h2 className="text-3xl font-semibold">Services</h2>
          <ButtonPrimary onClick={() => redirectToServiceForm()}>Create service</ButtonPrimary>
        </div>
        <div>
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="mt-8">
                <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {services.map((service) => (
                    <div
                      key={service.id}
                      onClick={() => redirectToService(service)}
                    >
                      <CarCard redirectToServiceForm={(e: any) => {
                        e.stopPropagation();
                        redirectToServiceForm(service);
                      }} data={service}/>
                    </div>
                  ))}
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>

          {!services.length && fetched && (
            <NotFound description={"No services found for your company."}/>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountServices;
